import React from "react";
import {LoaderTypes} from "../../../containers/RegistrationLoginPage/types";
import {CommonFieldContentLoader} from "../../HTMLEntities/SelectV2/widgets/CommonFieldContentLoader";
import {RangeInputLoader} from "../../RangeInput/widgets/RangeInputLoader";
import {RadioButtonLoader} from "../../HTMLEntities/RadioButton/widgets/RadioButtonLoader";
import {CheckBoxLoader} from "../../HTMLEntities/CheckBox/widgets/CheckBoxLoader";
import {ExamScoreLoader} from "./Fields/ExamScore/ExamScoreLoader";
import {FormUlList} from "./loaderStyled";

interface FieldLoader {
    loaderType: LoaderTypes;
    addEmptyLi: boolean;
    fullWidthDiv: boolean;
}
const FieldLoader: React.FC<FieldLoader> = ({
    loaderType,
    addEmptyLi,
    fullWidthDiv,
}: FieldLoader) => {
    let jsx;

    switch (loaderType) {
        case "Exam Loader":
            jsx = <ExamScoreLoader />;
            break;
        case "Range Input":
            jsx = <RangeInputLoader />;
            break;
        case "Radio Button":
            jsx = <RadioButtonLoader />;
            break;
        case "Checkbox":
            jsx = <CheckBoxLoader />;
            break;
        default:
            jsx = <CommonFieldContentLoader />;
            break;
    }

    return (
        <>
            <FormUlList fullWidthDiv={fullWidthDiv}>{jsx}</FormUlList>
            {addEmptyLi && <FormUlList />}
        </>
    );
};

export default FieldLoader;
